<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="jsa.jsa_name + ' [JSA Template] :: MeritEHS'"/>

            <div class="container d-print-none">
                <h4 class="py-3 mb-4">
                    <ol class="breadcrumb font-weight-bold m-0">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/jsa/templates`">
                                <i class="fa fa-files-o"></i> JSA Templates
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/jsa/templates/view/${jsa_id}`">
                                {{ jsa.jsa_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-file-pdf-o"></i> PDF
                        </li>
                    </ol>
                </h4>
            </div>
            <div class="container bg-white d-print-none py-4 mb-4">
                <div class="alert alert-info">
                    <strong>How to Export as PDF:</strong>
                    <ol>
                        <li>On your browser, there should be a "File" or "Options" tab with a "Print" option. You may also hold down the "Ctrl" key and press the "P" key.</li>
                        <li>This will bring up the print page options box. There should be an option called "Select Printer" or "Destination".</li>
                        <li>Select "Save as PDF" or "Adobe PDF".</li>
                        <li>Click "Save" or "Print". This will open your file explorer and let you save it to your computer as a PDF.</li>
                    </ol>
                </div>
            </div>

            <div class="container bg-white py-4">
                <h4 class="mb-4">
                    {{ jsa.jsa_name }}
                </h4>
                <div class="row mb-2">
                    <div class="col text-muted">JSA Name</div>
                    <div class="col-md-8">{{ jsa.jsa_name }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Contractor</div>
                    <div class="col-md-8">{{ jsa.jsa_contractor }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Total # of Steps</div>
                    <div class="col-md-8">{{ totalSteps }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Total # of Hazards</div>
                    <div class="col-md-8">{{ totalHazards }}</div>
                </div>

                <hr/>

                <div class="row mb-2">
                    <div class="col text-muted">Building/Area:</div>
                    <div class="col-md-8">{{ jsa.jsa_building_area }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Description of Work:</div>
                    <div class="col-md-8">{{ jsa.jsa_description }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Standard PPE:</div>
                    <div class="col-md-8">{{ jsa.jsa_safety_equipment }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Specialized PPE:</div>
                    <div class="col-md-8">{{ jsa.jsa_specialized_equipment }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col text-muted">Monitoring Activities:</div>
                    <div class="col-md-8">{{ jsa.jsa_monitoring_act }}</div>
                </div>

                <hr/>

                <strong slot="header">Steps and Hazards</strong>
                <ol>
                   <li v-for="step in jsa.jsa_steps" class="mb-2">
                        {{ step.step_label }}
                        <ul>
                           <li v-for="hazard in step.hazards" class="mb-1">
                                <span :class="`text-${getRacLevelColor(hazard.rac_level)}`">{{ hazard.rac_level }}</span>
                                {{ hazard.hazard }}
                                |
                                <span class="text-primary" title="Standard Controls">
                                    <template v-for="(control, index) in hazard.controls"><template v-if="index > 0">, </template>{{ control }}</template>
                                    <template v-if="hazard.other_controls">{{ hazard.other_controls }}</template>
                                </span>
                           </li>
                        </ul>
                   </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                jsa_id: this.$route.params.id,
                jsa: {},
            }
        },

        computed: {
            totalSteps(){
                //Send it
                return this.jsa.jsa_steps.length;
            },

            totalHazards(){
                //Start it
                var t = 0;

                //Loop and count
                for (var i = this.jsa.jsa_steps.length - 1; i >= 0; i--)
                {
                    t += this.jsa.jsa_steps[i].hazards.length;
                }

                //Send it
                return t;
            },
        },

        methods: {
            getRacLevelColor(level){
                //switch
                switch(level)
                {
                    case 'Extremely High':
                        return 'danger';
                        break;
                    case 'High':
                        return 'orange';
                        break;
                    case 'Medium':
                        return 'warning';
                        break;
                    case 'Low':
                        return 'success';
                        break;

                }

                return 'success';
            },

            getJsa: function() {
                //Get the data
                this.$http
                    .get('jsa/templates/view/' + this.jsa_id)
                    .then(response => {
                        //Set all the data
                        this.jsa = response.data.jsa;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the JSA
            this.getJsa();
        }
    }
</script>
<style scoped>
.text-orange {
    color: #ef871d;
}
.break-protect {
    page-break-inside: avoid;
}
.body {
    margin: 25mm;
}
@page {
    margin-top: 1in;
    margin-bottom: 1in;
}
</style>